<template>
  <div v-if="stepper.stepNames" class="box mb-4">
    <div class="d-flex justify-content-between w-100 stepper">
      <template v-for="(name, step, index) in stepper.stepNames" :key="step">
        <Link
          :step="step"
          :href="route(`${routePrefix}.${resourceType}.${action}`, resource.data.id, { step })"
          class="step-link"
          :class="getStepperClass(step)"
          @click.prevent="updateStep(route(`${routePrefix}.${resourceType}.${updateAction}`, resource.data.id), step)"
        >
          <span
            ><template v-if="options.showTitles">{{ name }}</template></span
          >
        </Link>
        <div v-if="!getStepperClass(step)" class="current-step">
          <h2>Schritt {{ index + 1 }}/{{ Object.values(stepper.stepNames).length }}</h2>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import { ref } from 'vue';
import useStepper from '@kanrisha/composables/useStepper';

export default {
  components: {
    Link,
  },
  props: {
    action: { type: String, default: () => 'edit' },
    updateAction: { type: String, default: () => 'update' },
    stepper: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
    options: { type: Object, default: () => {} },
  },
  setup(props) {
    const resourceType = ref(props.resource.meta.resourceType);
    const { getStepperClass, steps, updateStep } = useStepper(props);

    return {
      getStepperClass,
      resourceType,
      steps,
      updateStep,
    };
  },
};
</script>
